var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"loader"})]):_c('router-view',{attrs:{"mfaToken":_vm.mfaToken,"authenticatorList":_vm.authenticatorList,"state":_vm.state}})}
var staticRenderFns = []

export { render, staticRenderFns }